import React from "react";
import { Save } from "lucide-react";

const StatisticsForm = ({ statsData, setStatsData, onSave }) => {
  const cardCls = "bg-white rounded-xl shadow p-8 mb-10";
  const labelCls = "block text-sm font-medium text-gray-700 mb-1";
  const inputCls =
    "w-full border rounded-lg px-3 py-2 shadow-sm focus:ring-2 focus:ring-blue-400 outline-none";

  // always show exactly 3 rows
  const fixedStats = [
    statsData[0] || { value: "", label: "" },
    statsData[1] || { value: "", label: "" },
    statsData[2] || { value: "", label: "" },
  ];

  const updateStat = (index, field, value) => {
    setStatsData((prev) => {
      const copy = [...prev];
      // ensure length >= 3
      while (copy.length < 3) {
        copy.push({ value: "", label: "" });
      }
      copy[index] = { ...copy[index], [field]: value };
      return copy.slice(0, 3); // keep only 3
    });
  };

  return (
    <section className={cardCls}>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-semibold text-blue-700">
          Statistics Section
        </h2>
        <button
          onClick={onSave}
          className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg"
          type="button"
        >
          <Save size={18} /> Save
        </button>
      </div>

      <div className="space-y-6">
        {fixedStats.map((stat, index) => (
          <div
            key={index}
            className="border border-gray-200 rounded-lg p-6 relative"
          >
            <div className="grid md:grid-cols-2 gap-4">
              <div>
                <label className={labelCls}>Value</label>
                <input
                  value={stat.value}
                  onChange={(e) => updateStat(index, "value", e.target.value)}
                  className={inputCls}
                  placeholder="e.g., 18+ lakh"
                />
              </div>
              <div>
                <label className={labelCls}>Label</label>
                <input
                  value={stat.label}
                  onChange={(e) => updateStat(index, "label", e.target.value)}
                  className={inputCls}
                  placeholder="e.g., sq. ft. delivered"
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StatisticsForm;
